<template>
  <div
    class="drawer-info__content"
    data-ui-section="drawer-content"
  >
    <h4 class="m-0">
      {{ title }}
    </h4>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-info__content {
  h4 {
    margin-bottom: 0.8em;
    white-space: normal;
    line-height: 1.25;
    overflow-x: hidden;
  }

  &.closed {
    height: 3em;
    overflow-y: hidden;
  }
}

</style>
